import React from "react";
import { eventEmitter, navigate } from "../../../services";

import Step, { Container } from "./styles/onboarding";
// import Steps from './Steps'

import Share from "./Share";
import CreateBook from "./CreateBook";
import { EVT_USER_REGISTER } from "../../../components/Forms/RegisterForm";
import { EVT_DOC_CREATE } from "../../../components/Forms/DocForm";
import RegisterForm from "../../../components/Forms/RegisterForm";
import Start from "./Start";
import { TYPE_INFO } from "../../../lib/ui";

export default class OnBoarding extends React.Component {
    state = {
        step: 1,
        doc_id: -1,
        page_id: -1,
    };

    componentDidMount() {
        eventEmitter.on(EVT_USER_REGISTER, this.onRegister);
        eventEmitter.on(EVT_DOC_CREATE, this.onDocCreate);
    }

    componentWillUnmount() {
        eventEmitter.off(EVT_USER_REGISTER, this.onRegister);
        eventEmitter.off(EVT_DOC_CREATE, this.onDocCreate);
    }

    onRegister = () => this.setState({ step: 2 });
    onShareNext = () => this.setState({ step: 3 });
    onDocCreate = ({ doc_id, page_id }: { doc_id: number; page_id: number }) =>
        this.setState({ doc_id, page_id, step: 4 });

    onStart = () => {
        const { doc_id, page_id } = this.state;
        navigate.to(`/app/e/${doc_id}/${page_id}`);
    };

    view() {
        const { step } = this.state;

        if (step === 1) {
            return (
                <Step title="رجسٹریشن">
                    <RegisterForm redirect={false} primaryBtnType={TYPE_INFO} />
                </Step>
            );
        } else if (step === 2) {
            return (
                <Step title="شئیر">
                    <Share onNext={this.onShareNext} />
                </Step>
            );
        } else if (step === 3) {
            return (
                <Step title="کتاب کا نام">
                    <CreateBook />
                </Step>
            );
        } else if (step === 4) {
            return (
                <Step title="سسٹم کے اندر">
                    <Start onStart={this.onStart} />
                </Step>
            );
        }

        return null;
    }

    render() {
        return (
            <Container>
                {/*<Steps step={this.state.step} />*/}
                {this.view()}
            </Container>
        );
    }
}
